module.exports = __webpack_public_path__ + "static/img/wxk_success_bg.f7eaff1d.png";